import { t as Swiper } from "./swiper-bundle.esm.js";
//#region frontend/entrypoints/sf-shindan.js
var ShindanObject = class {
	constructor(container) {
		this.container = container;
		this.initialQuestionId = container.dataset.initialQuestion;
		this.currentQuestionId = null;
		this.questionHistory = [];
		this.isLoading = false;
		this.elements = {
			questionWrapper: container.querySelector("[data-shindan-question]"),
			questionNumber: container.querySelector("[data-shindan-number]"),
			questionText: container.querySelector("[data-shindan-text]"),
			answersContainer: container.querySelector("[data-shindan-answers]"),
			backPrevBtn: container.querySelector("[data-shindan-back-prev]"),
			backBtn: container.querySelector("[data-shindan-back]"),
			resultWrapper: container.querySelector("[data-shindan-result]"),
			productsContainer: container.querySelector("[data-shindan-products]"),
			restartBtn: container.querySelector("[data-shindan-restart]"),
			loading: container.querySelector("[data-shindan-loading]")
		};
		this.init();
	}
	init() {
		this.elements.backPrevBtn?.addEventListener("click", () => this.goPrevious());
		this.elements.backBtn?.addEventListener("click", () => this.goBack());
		this.elements.restartBtn?.addEventListener("click", () => this.restart());
		this.loadQuestion(this.initialQuestionId);
	}
	async loadQuestion(questionId) {
		this.isLoading = true;
		this.showLoading();
		try {
			const question = await this.fetchQuestion(questionId);
			this.currentQuestionId = questionId;
			this.renderQuestion(question);
			this.showScreen(this.elements.questionWrapper);
		} catch (error) {
			console.error("質問の読み込みに失敗しました:", error);
			alert("質問の読み込みに失敗しました。もう一度お試しください。");
		} finally {
			this.hideLoading();
			this.isLoading = false;
		}
	}
	async fetchQuestion(questionId) {
		const question = window.shindanData?.questions?.[questionId];
		if (!question) throw new Error("Question not found: " + questionId);
		return question;
	}
	renderQuestion(question) {
		this.elements.questionNumber.textContent = "Q" + question.number;
		this.elements.questionText.textContent = question.text;
		this.elements.answersContainer.innerHTML = "";
		question.answers.forEach((answer, index) => {
			const button = document.createElement("button");
			button.className = "p-shindan__answer";
			button.dataset.answerIndex = index;
			if (answer.icon) {
				const icon = document.createElement("img");
				icon.className = "p-shindan__answer-icon";
				icon.src = answer.icon;
				icon.alt = "";
				button.appendChild(icon);
			}
			const text = document.createElement("span");
			text.className = "p-shindan__answer-text";
			text.textContent = answer.text;
			button.appendChild(text);
			button.addEventListener("click", () => this.handleAnswer(answer));
			this.elements.answersContainer.appendChild(button);
		});
		if (this.questionHistory.length > 0) {
			this.elements.backPrevBtn.style.display = "block";
			this.elements.backBtn.style.display = "block";
		} else {
			this.elements.backPrevBtn.style.display = "none";
			this.elements.backBtn.style.display = "none";
		}
	}
	async handleAnswer(answer) {
		if (this.isLoading) return;
		this.questionHistory.push(this.currentQuestionId);
		if (answer.result) await this.loadResult(answer.result);
		else if (answer.next) await this.loadQuestion(answer.next);
		else {
			console.error("次の質問または結果が設定されていません");
			alert("診断フローの設定に問題があります。");
		}
	}
	async loadResult(resultId) {
		this.isLoading = true;
		this.showLoading();
		try {
			const result = await this.fetchResult(resultId);
			this.hideScreen(this.elements.questionWrapper);
			this.showScreen(this.elements.resultWrapper);
			await this.renderResult(result);
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		} catch (error) {
			console.error("結果の読み込みに失敗しました:", error);
			alert("結果の読み込みに失敗しました。もう一度お試しください。");
		} finally {
			this.hideLoading();
			this.isLoading = false;
		}
	}
	async fetchResult(resultId) {
		const result = window.shindanData?.results?.[resultId];
		if (!result) throw new Error("Result not found");
		return result;
	}
	async renderResult(result) {
		this.elements.productsContainer.innerHTML = "";
		if (result.productHandles.length === 0) {
			this.elements.productsContainer.innerHTML = "<p>おすすめ商品が見つかりませんでした。</p>";
			return;
		}
		const products = await this.fetchProducts(result.productHandles);
		if (products.length === 1) this.renderSingleProduct(products[0]);
		else this.renderProductSlider(products);
	}
	async fetchProducts(handles) {
		const products = [];
		for (const handle of handles) try {
			const response = await fetch(`/products/${handle}.js`);
			if (response.ok) {
				const product = await response.json();
				products.push(product);
			}
		} catch (error) {
			console.error(`商品の取得に失敗: ${handle}`, error);
		}
		return products;
	}
	renderSingleProduct(product) {
		const productCard = this.createProductCard(product);
		const singleCard = document.createElement("div");
		singleCard.className = "p-shindan__result-products--single";
		singleCard.appendChild(productCard);
		this.elements.productsContainer.appendChild(singleCard);
	}
	renderProductSlider(products) {
		const swiperContainer = document.createElement("div");
		swiperContainer.className = "swiper p-shindan__slider";
		const wrapper = document.createElement("div");
		wrapper.className = "swiper-wrapper";
		products.forEach((product) => {
			const slide = document.createElement("div");
			slide.className = "swiper-slide";
			slide.appendChild(this.createProductCard(product));
			wrapper.appendChild(slide);
		});
		swiperContainer.appendChild(wrapper);
		const prevBtn = document.createElement("div");
		prevBtn.className = "swiper-button-prev p-shindan__slider-prev";
		const nextBtn = document.createElement("div");
		nextBtn.className = "swiper-button-next p-shindan__slider-next";
		if (products.length > 2 && window.innerWidth >= 750 || products.length > 1 && window.innerWidth < 750) {
			const prevImg = document.createElement("img");
			prevImg.src = "/cdn/shop/t/9/assets/arrow-prev.svg?v=130261885339343882211772157996";
			prevImg.alt = "前へ";
			prevBtn.appendChild(prevImg);
			const nextImg = document.createElement("img");
			nextImg.src = "/cdn/shop/t/9/assets/arrow-next.svg?v=90039623152598507181772157996";
			nextImg.alt = "次へ";
			nextBtn.appendChild(nextImg);
		}
		const pagination = document.createElement("div");
		pagination.className = "swiper-pagination";
		swiperContainer.appendChild(prevBtn);
		swiperContainer.appendChild(pagination);
		swiperContainer.appendChild(nextBtn);
		this.elements.productsContainer.appendChild(swiperContainer);
		this.initSwiper(swiperContainer, prevBtn, nextBtn, pagination);
	}
	createProductCard(product) {
		const card = document.createElement("a");
		card.className = "p-shindan__product-card";
		card.href = `/products/${product.handle}`;
		const image = document.createElement("img");
		image.className = "p-shindan__product-image";
		image.src = product.featured_image || "";
		image.alt = product.title;
		const content = document.createElement("div");
		content.className = "p-shindan__product-content";
		const title = document.createElement("h3");
		title.className = "p-shindan__product-title";
		title.textContent = product.title;
		const price = document.createElement("span");
		price.className = "p-shindan__product-price";
		price.textContent = this.formatPrice(product.price) + "（税込）";
		content.appendChild(title);
		content.appendChild(price);
		card.appendChild(image);
		card.appendChild(content);
		return card;
	}
	initSwiper(container, prevBtn, nextBtn, pagination) {
		new Swiper(container, {
			slidesPerView: 1.4,
			spaceBetween: 20,
			centeredSlides: true,
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
				addIcons: false
			},
			pagination: {
				el: pagination,
				clickable: true
			},
			breakpoints: { 750: {
				slidesPerView: 2,
				spaceBetween: 30,
				centeredSlides: false
			} }
		});
	}
	formatPrice(price) {
		return new Intl.NumberFormat("ja-JP", {
			style: "currency",
			currency: "JPY"
		}).format(price / 100);
	}
	goPrevious() {
		if (this.questionHistory.length === 0) return;
		const prevId = this.questionHistory.pop();
		this.loadQuestion(prevId);
	}
	goBack() {
		this.questionHistory = [];
		this.loadQuestion(this.initialQuestionId);
	}
	restart() {
		this.questionHistory = [];
		this.hideScreen(this.elements.resultWrapper);
		this.loadQuestion(this.initialQuestionId);
	}
	showScreen(element) {
		element.style.display = "block";
		element.classList.add("is-visible");
	}
	hideScreen(element) {
		element.classList.remove("is-visible");
		element.style.display = "none";
	}
	showLoading() {
		this.elements.loading.style.display = "flex";
	}
	hideLoading() {
		this.elements.loading.style.display = "none";
	}
};
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll("[data-shindan-container]").forEach((container) => new ShindanObject(container));
});
//#endregion
